import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getSurveyDetail = ({ version = 'v1', id, params }) =>
  client
    .request({
      url: `${version}/surveys/survey-detail/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const syncSurvey = ({ data, version = 'v1', params = {} }) =>
  client
    .request({
      url: `${version}/surveys/survey/sync/`,
      method: RequestMethod.PUT,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSyncSurvey = ({ version = 'v1', id, params }) =>
  client
    .request({
      url: `${version}/surveys/survey/sync/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSyncSurveyInstance = ({ version = 'v1', id, params }) =>
  client
    .request({
      url: `${version}/surveys/survey/sync/instance/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyInstanceTemplate = ({ version = 'v1', id, params }) =>
  client
    .request({
      url: `${version}/surveys/instances/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSurvey = ({ version = 'v1', id, data }) =>
  client
    .request({
      url: `${version}/surveys/${id}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addSurvey = ({ version = 'v1', data }) =>
  client
    .request({
      url: `${version}/surveys/survey-detail/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyOptionGroupList = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/surveys/option-groups/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateQuestionById = ({
  version = 'v1',
  surveyId,
  questionId,
  data,
}) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/questions-pk/${questionId}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addQuestion = ({ version = 'v1', surveyId, data }) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/questions-pk/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addCategory = ({ version = 'v1', data }) =>
  client
    .request({
      url: `${version}/surveys/categories/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateCategoryById = ({ version = 'v1', id, data }) =>
  client
    .request({
      url: `${version}/surveys/categories/${id}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteCategory = ({ version = 'v1', id }) => {
  client
    .request({
      url: `${version}/surveys/categories/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const updateOptionChoiceById = ({
  version = 'v1',
  surveyId,
  optionChoiceId,
  data,
}) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/question-choices-pk/${optionChoiceId}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addOptionChoice = ({ version = 'v1', surveyId, data }) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/question-choices-pk/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteQuestion = ({ version = 'v1', surveyId, questionId }) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/questions-pk/${questionId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteOptionChoice = ({
  version = 'v1',
  surveyId,
  optionChoiceId,
}) =>
  client
    .request({
      url: `${version}/surveys/${surveyId}/question-choices-pk/${optionChoiceId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLearningTaskList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/learning-tasks/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLearningTaskListCounts = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/learning-tasks/counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivityList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/activities/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivityListCounts = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/activities/counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getGlobalSurveysCount = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/global_count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyInstanceList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyInstanceListCounts = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyInstanceDueDates = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/due_dates/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getDistrictSurveyList = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/survey-bank/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyAnalyticsQuestionList = ({
  id,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/${id}/analytics/questions/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyAnalyticsCount = ({ id, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/${id}/count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAnalyticsStudentList = ({
  questionId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/question/${questionId}/option/students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getQuestionTextResponseList = ({
  id,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/questions/${id}/search/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getQuestionStaffSelectResponseList = ({
  id,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/questions/${id}/staff-selector/search/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAnalyticsVideoResponseSearchList = ({
  id,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/questions/${id}/video-responses/search/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createUserSurvey = ({ payload, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/user-surveys/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const saveSurveyAnswer = ({
  surveyId,
  payload,
  params = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/${surveyId}/answers-pk/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyAnswer = ({ surveyId, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/user-surveys/${surveyId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLatestUserSurveyResults = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/user-surveys/latest/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyAnalyticsReport = ({
  id,
  data,
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/${id}/export/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getIndividualPdfForEachStudent = ({
  surveyInstanceId,
  data,
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/${surveyInstanceId}/user-responses/export/zip/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCombinedPdfForEachStudent = ({
  surveyInstanceId,
  data,
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/${surveyInstanceId}/user-responses/export/pdf/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUserSurveyResponsesPdf = ({
  userSurveyId,
  data,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/user-response/${userSurveyId}/export/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyFilesZip = ({ data, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/files/export/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyVideosZip = ({ data, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/analytics/survey/videos/export/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const addAnswerFileList = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/answer-files/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteAnswerFile = ({ id, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/instances/answer-files/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSurvey = ({ id, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/survey-detail/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSurveyStatus = ({ version = 'v1', id, data }) =>
  client
    .request({
      url: `${version}/surveys/${id}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const duplicateSurvey = ({ id, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/surveys/survey-detail/${id}/duplicate/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSurveyInstance = ({ version = 'v1', data }) =>
  client
    .request({
      url: `${version}/surveys/instances/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFlowLogic = ({ version = 'v1', id, params = {} }) =>
  client
    .request({
      url: `${version}/surveys/${id}/flow-logic/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createFlowLogic = ({ version = 'v1', data, id }) =>
  client
    .request({
      url: `${version}/surveys/${id}/flow-logic/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateFlowLogic = ({ version = 'v1', id, data }) =>
  client
    .request({
      url: `${version}/surveys/flow-logic/${id}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteFlowLogic = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/surveys/flow-logic/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEndLogic = ({ version = 'v1', id, params = {} }) =>
  client
    .request({
      url: `${version}/surveys/${id}/end-logic/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createEndLogic = ({ version = 'v1', data, params = {} }) =>
  client
    .request({
      url: `${version}/surveys/end-logic/`,
      method: RequestMethod.POST,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateEndLogic = ({ version = 'v1', id, data, params = {} }) =>
  client
    .request({
      url: `${version}/surveys/end-logic/${id}/`,
      method: RequestMethod.PATCH,
      data,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteEndLogic = ({ version = 'v1', id, params = {} }) =>
  client
    .request({
      url: `${version}/surveys/end-logic/${id}/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentsSurveyCount = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/surveys/user-surveys/student-dashboard-count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentSurveys = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/surveys/user-surveys/student-dashboard/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSurveyInstance = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/surveys/instances/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * @param {number} questionId
 * @param {number} optionId
 * @param {string} params.event
 * @param {number} params.instanceId
 */
export const exportSurveyAnalyticsQuestions = ({
  version = 'v1',
  questionId,
  params,
}) =>
  client
    .request({
      url: `${version}/surveys/analytics/question/${questionId}/option/students/export/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * @param {number} questionId
 * @param {number} optionId
 * @param {string} params.event
 * @param {number} params.instanceId
 */
export const getUserListHash = ({ version = 'v1', questionId, params }) =>
  client
    .request({
      url: `${version}/surveys/analytics/question/${questionId}/option/students/hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * @param {number} params.student -> Pass student param on student casefile page for k12_admins
 */
export const getBragSheetUserSurvey = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/surveys/user-survey-for-brag-sheet-indicator/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
